import uScope from '../uScope/js/public-api';

import 'uScope/js/hmi/mouse/index';
import 'uScope/js/hmi/keyboard/index';
import 'uScope/js/hmi/touch/index';

export default uScope;



// WEBPACK FOOTER //
// ./src/lib/uscope.js